import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllMarkupUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllMarkup/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarkupUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllMarkupUser;
};


const setActiveMarkup = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setMarkupActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarkupUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Markup  - ',response);


    return AllMarkupUser;
};



const setDeletedMarkup = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setMarkupDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarkupUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Markup  - ',response);


    return AllMarkupUser;
};




const setUpdateMarkup = async (dataMarkupUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setMarkupUpdate/'),{
        dataMarkupUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarkupUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Markup  - ',dataMarkupUpdate,response);


    return AllMarkupUser;
};


const setSaveNewMarkup = async (dataMarkupUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewMarkup/'),{
        dataMarkupUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarkupUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Markup  - ',response);


    return AllMarkupUser;
};

Mock.onGet('/api/reference/getAllMarkup').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllMarkupUser = await getAllMarkupUser();
    // console.log('С сервера пришло - ', AllMarkupUser);

    // if (!AllMarkupUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllMarkupUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllMarkupUser,
    ]


})


Mock.onPost('/api/reference/setActiveMarkup').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllMarkupUser = await setActiveMarkup(id,val);

    // if (!AllMarkupUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllMarkupUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllMarkupUser,
    ]


})

Mock.onPost('/api/reference/setDeletedMarkup').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllMarkupUser = await setDeletedMarkup(id,val);

    // if (!AllMarkupUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllMarkupUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllMarkupUser,
    ]


})


Mock.onPost('/api/reference/setUpdateMarkup').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataMarkupUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Markup = await setUpdateMarkup(dataMarkupUpdate);

    // console.log('Серовер вернул данные ',AllMarkupUser);

    // if (!Markup) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Markup) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Markup,
    ]


})


Mock.onPost('/api/reference/setSaveNewMarkup').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataMarkupUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Markup = await setSaveNewMarkup(dataMarkupUpdate);

    // console.log('Серовер вернул данные ',AllMarkupUser);

    // if (!Markup) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Markup) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Markup,
    ]
})